import React, { useState } from "react";
import "./view-leave-request.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
let ViewLeaveRequest = (props) => {
  const navigate = useNavigate();
  let [rejecet, setReject] = useState(false);
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Leave title:</p>
          <p className="view-leave-request-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Start Date - End Date:</p>
          <p className="view-leave-request-description">
            03-03-2022 - 04-03-2022
          </p>
        </div>
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Leave Description</p>
        </div>
        <p className="view-leave-request-description">
          Dear sir/mam <br />
          <br />
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
          <br />
          <br />
          Best Regards <br />
          David Anderson
        </p>
        <br />
        <br />
        <Box sx={{ flexGrow: 1 }}>
          {!rejecet && (
            <Grid container spacing={2}>
              <Grid item xl={2} lg={2} md={2} sm={2} xs={2}></Grid>
              <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                <Button
                  className="view-leave-request-reject-button"
                  variant="text"
                  onClick={() => setReject(true)}
                >
                  Reject
                </Button>
              </Grid>
              <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                <Button
                  className="view-leave-request-accept-button"
                  variant="text"
                  onClick={() => navigate(-1)}
                >
                  Accept
                </Button>
              </Grid>
            </Grid>
          )}
          {rejecet && (
            <div>
              <Grid container spacing={2}>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div>
                    <p className="input-heading">Your Reason</p>
                    <textarea
                      className="textarea"
                      placeholder="Write your Reason..."
                      rows="20"
                      cols="40"
                    ></textarea>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xl={4} lg={4} md={4} sm={2} xs={2}></Grid>
                <Grid item xl={4} lg={4} md={4} sm={8} xs={8}>
                  <Button
                    className="form-button"
                    variant="text"
                    onClick={() => navigate(-1)}
                  >
                    Submit
                  </Button>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={2} xs={2}></Grid>
              </Grid>
            </div>
          )}
        </Box>
      </div>
    </SideMenu>
  );
};
export default ViewLeaveRequest;
